import throttle from '../utils/throttle';

export default class Recruitment {
    constructor() {
        this.slider = document.querySelector('.recruitment__steps-slider');
        this.progress = document.querySelector('.recruitment__steps-progress');
        this.progressBar = document.querySelector('.recruitment__steps-progress-bar');
        this.markerContainer = document.querySelector('.recruitment__steps-markers');
        this.markers = this.markerContainer.querySelectorAll('.recruitment__steps-marker');

        this.slider.addEventListener('slideChange', throttle((e) => {this.onChange(e.detail)}, 10))

        if (window.innerWidth >= 1280) {
            this.slider.querySelector('.last').classList.add('slider__item')
        }
    }

    onChange(e) {
        const marker = this.markers[e.relativeSlide]
        const pos = marker.offsetLeft
        const center = marker.offsetWidth / 2

        this.progressBar.style.transform = `translate(${pos + center}px)`

        if (window.innerWidth < 1024) {
            this.progress.style.transform = `translate(-${pos}px)`   
        }
    }
}